import { View } from "./Diagnoses.view";

export const Container = () => {
  return <View />;
};
